require('./bootstrap');

// Import modules...
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

const el = document.getElementById('app');

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}`),
    setup({ el, app, props, plugin }) {
        const iApp = createApp({ render: () => h(app, props) })

        iApp.config.globalProperties.$isEmpty = str => (!str && str !== 0) || 0 === str.length
        iApp.config.globalProperties.$numberFormat = (x = null, y = 0) =>
            x !== null
                ? x.toLocaleString(undefined, {
                    minimumFractionDigits: y,
                    maximumFractionDigits: 2
                })
                : x

        iApp.mixin({ methods: { route } })
            .use(plugin)
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });
